import * as stylex from '@stylexjs/stylex';
import type { VarGroup } from '@stylexjs/stylex/lib/StyleXTypes';
export type TFonts = Readonly<{
  din2014Demi: string;
  din2014Regular: string;
}>;
export const fonts: VarGroup<TFonts> = stylex.defineVars({
  din2014Demi: 'DIN-2014_Demi',
  din2014Regular: 'DIN-2014_Regular',
});
